import script from "./contentTemp.vue?vue&type=script&setup=true&lang=js"
export * from "./contentTemp.vue?vue&type=script&setup=true&lang=js"

import "./contentTemp.vue?vue&type=style&index=0&id=7abc681d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7abc681d"]])

export default __exports__